<template>
  <div class="myAlumniMeeting">
    <div
      class="alumniMeeting clearfix"
      v-for="item in this.meeting"
      :key="item.id"
      @click="gotoMeetingDetail(item.id)"
    >
      <div class="meetingImgDiv">
        <img :src="item.img" alt="校友会图片" class="meetingImg" />
      </div>
      <div class="data">
        <div class="meetingName">{{ item.title }}</div>
        <div class="meetingPresident">会长：{{ item.mastorName }}</div>
        <div class="joinDate">加入时间：{{ item.createTime.slice(0, 10) }}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      meeting: "",
      user_id: window.localStorage.getItem("user_id"),
    };
  },
  created() {
    this.getMine();
  },
  methods: {
    async getMine() {
       const result = await this.$http.get("/my/myBranch", {
        params: { userId: window.localStorage.getItem("user_id") },
      });
      this.meeting = result.data;
    },
    gotoIndex() {
      return this.$router.push("/");
    },
    gotoMeetingDetail(id) {
      return this.$router.push({
        path: "/meetingDetails",
        query: { bid: id, user_id: window.localStorage.getItem("user_id") },
      });
    },
  },
};
</script>
<style lang="less" scoped>
.clearfix:after {
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
.clearfix {
  *zoom: 1;
}
.myAlumniMeeting {
  position: relative;
  .alumniMeeting {
    position: relative;
    left: 5%;
    width: 90%;
    margin: 20px 0;
    background: #ffffff;
    border: 1px solid #e1e1e1;
    border-radius: 15px;
    .meetingImgDiv {
      float: left;
      margin: 10px 10px;
      width: 40%;
      height: 13vh;
      .meetingImg {
        width: 100%;
        height: 100%;
        border-radius: 15px;
      }
    }
    .data {
      float: left;
      margin: 15px 0 0 5px;
      .meetingName {
        font-size: 1.19rem;
        font-weight: bold;
        color: #333333;
      }
      .meetingPresident {
        margin-top: 5%;
        font-size: 1.08rem;
        font-weight: bold;
        color: #666666;
      }
      .joinDate {
        margin-top: 15%;
        font-weight: 400;
        color: #999999;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/mine/MyAlumniMeeting.vue